const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export const isValidNewsletterEmail = (value) => EMAIL_REGEX.test(String(value || "").trim());

export const parseNewsletterCsv = (text) => {
  if (!text || !String(text).trim()) {
    return { validEmails: [], invalidLines: [], duplicateCount: 0 };
  }

  const lines = String(text)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const validEmails = [];
  const invalidLines = [];
  const seen = new Set();
  let duplicateCount = 0;

  lines.forEach((line, index) => {
    const candidate = line.split(/[,;\t]/)[0].trim().replace(/^["']|["']$/g, "").toLowerCase();
    if (!candidate) {
      invalidLines.push({ line: index + 1, value: line, reason: "Riga vuota" });
      return;
    }
    if (!isValidNewsletterEmail(candidate)) {
      invalidLines.push({ line: index + 1, value: line, reason: "Email non valida" });
      return;
    }
    if (seen.has(candidate)) {
      duplicateCount += 1;
      return;
    }
    seen.add(candidate);
    validEmails.push(candidate);
  });

  return { validEmails, invalidLines, duplicateCount };
};
